type StorageKind = "localStorage" | "sessionStorage";

/** Browser storage is an optional convenience, never canonical workflow state. */
export function readBrowserStorage(kind: StorageKind, key: string): string | null {
  try {
    return typeof window === "undefined" ? null : window[kind].getItem(key);
  } catch {
    // Privacy settings can throw even when accessing the storage property.
    return null;
  }
}

export function writeBrowserStorage(kind: StorageKind, key: string, value: string): void {
  try {
    if (typeof window !== "undefined") window[kind].setItem(key, value);
  } catch {
    // Keep the current in-memory view usable when storage is blocked or full.
  }
}
